import {connect} from 'react-redux';
import {actions} from '../../actions/actions';
import {Modal} from '../modal/modal';

export const ModalContainer = connect(
  function mapStateToProps(state) {
    return {
      authenticated: state.authReducer.authenticated,
      online: state.onlineReducer.online,
      error: state.errorReducer.error,
      errorStatus: state.errorReducer.errorStatus
    };
  },
  function mapDispatchToProps(dispatch){
      return{
        onAuthenticationChange: (bool) => {
         if(bool){
           dispatch( actions.authenticate() );
         }else{
           dispatch( actions.unauthenticate() );
         }
       },
       onCloseError: ()=>{
         dispatch( actions.error('', 'acknowledged'))
       }
      }
  }

)(Modal);



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/containers/modalContainer.js